import styled, { css } from 'styled-components';
import { BottomViewHeader, BottomViewContent } from '../BottomView/styled';

const baseContactItem = css`
  display: flex;
  width: 100%;
  gap: 10px;
  height: 60px;
  align-items: center;
  text-decoration: none;
`;

export const ContactItemDiv = styled.div`
  ${baseContactItem}
`;

export const ContactItemLink = styled.a`
  ${baseContactItem}
`;

export const ContactItemIcon = styled.i`
  display: inline-block;
  width: 35px;
  text-align: center;

  svg path {
    fill: ${({ theme }) => theme.colors.text.primary};
  }
`;

export const ContactItemTitle = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 15px;
  font-weight: 400;
`;

export const ContactInfoBottomViewWrapper = styled.div`
  ${BottomViewHeader} {
    height: 35px;
    border: 0;
  }

  ${BottomViewContent} {
    padding: 5px 15px;
  }
`;
